import styled from 'styled-components';
import LocationSidebar from './LocationSidebar';

const NavPanel = ({
  swtName,
  switchData,
  flatSwitch,
  selectedLocation,
  selectedSpecificLocation,
  onSelectLocation,
}) => {
  return (
    <NavWrapper>
      <LocationSidebar
        swtName={swtName}
        switchData={switchData}
        flatSwitch={flatSwitch}
        selectedLocation={selectedLocation}
        selectedSpecificLocation={selectedSpecificLocation}
        onSelect={onSelectLocation}
      />
    </NavWrapper>
  );
};

export default NavPanel;

const NavWrapper = styled.div`
  width: 280px;
  min-width: 280px;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
